import React from "react";
import PublicAccess from "@features/public-access/components/PublicAccess";
import PublicProgram from "@features/public-access/components/PublicProgram";

const routes = [
  {
    path: "/public-access",
    element: <PublicAccess />,
    isProtected: false,
  },
  {
    path: "/public-program",
    element: <PublicProgram />,
    isProtected: false,
  },
];

export default routes;
